import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { EnvelopeSimple, ArrowLeft, Check } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_lesson-card-manager/artifacts/zd0x6jcg_c982a405-739a-4717-a6a0-d9774dc13353_20251118_231830_0000.png";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await axios.post(`${API}/auth/forgot-password`, { email });
            setSent(true);
        } catch (err) {
            setError('Er is iets misgegaan. Probeer het opnieuw.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#1A202C] flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <img src={LOGO_URL} alt="AutoPilot" className="w-20 h-20 mx-auto mb-4 object-contain" />
                    <h1 className="text-2xl font-bold text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
                        Rijschool <span className="text-[#D4A537]">AutoPilot</span>
                    </h1>
                </div>

                <div className="bg-[#2D3748] p-8 rounded-lg border border-[#4A5568]">
                    {sent ? (
                        <div className="text-center">
                            <div className="w-16 h-16 bg-[#D4A537]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Check size={32} className="text-[#D4A537]" />
                            </div>
                            <h2 className="text-xl font-semibold text-white mb-2">Email verstuurd!</h2>
                            <p className="text-gray-400 mb-6">
                                Als dit emailadres bij ons bekend is, ontvang je een link om je wachtwoord te resetten.
                            </p>
                            <Link to="/login">
                                <Button className="w-full bg-[#D4A537] text-[#1A202C] hover:bg-[#E5B84A] font-semibold">
                                    Terug naar inloggen
                                </Button>
                            </Link>
                        </div>
                    ) : (
                        <>
                            <h2 className="text-xl font-semibold text-white mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                                Wachtwoord vergeten?
                            </h2>
                            <p className="text-gray-400 mb-6 text-sm">
                                Vul je emailadres in en we sturen je een link om je wachtwoord te resetten.
                            </p>

                            {error && (
                                <div className="mb-4 p-3 bg-red-900/50 border border-red-700 rounded-md text-red-300 text-sm">{error}</div>
                            )}

                            <form onSubmit={handleSubmit} className="space-y-4">
                                <div className="space-y-2">
                                    <Label className="text-gray-300">Email</Label>
                                    <Input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="jouw@email.nl"
                                        required
                                        className="bg-[#1A202C] border-[#4A5568] text-white placeholder:text-gray-500"
                                        data-testid="forgot-email-input"
                                    />
                                </div>
                                <Button type="submit" disabled={loading}
                                    className="w-full bg-[#D4A537] text-[#1A202C] hover:bg-[#E5B84A] font-semibold"
                                    data-testid="forgot-submit-button">
                                    <EnvelopeSimple size={18} className="mr-2" />
                                    {loading ? 'Bezig...' : 'Reset link versturen'}
                                </Button>
                            </form>

                            <div className="mt-6 text-center">
                                <Link to="/login" className="text-[#D4A537] text-sm hover:underline flex items-center justify-center gap-1">
                                    <ArrowLeft size={14} /> Terug naar inloggen
                                </Link>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
